import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    outline: none;
  }
  body{
    background:${({ theme }) => theme.colors.background};
    font-size: 14px;
    color: ${({ theme }) => theme.colors.secondary100};
    font-family: 'Poppins', sans-serif;
  }
  ul{
    list-style: none;
    padding: 0;
    margin: 0;
  }
  table {
	border-collapse: collapse;
	border-spacing: 0;
}
  ::-webkit-scrollbar {
  width: 10px;
  
}

/* Track */
::-webkit-scrollbar-track {
  background: ${({ theme }) => theme.colors.background}; ; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: ${({ theme }) => theme.colors.primary}; 
  border-radius: 8px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
`;
